function maskFromString(str, customFormat) {
  if (customFormat) {
    return str.split('').map(function(char) {
      return !['-', '/', '.', ',', ' '].includes(char) ? /\d/ : char
    })
  } else {
    return str.split('').map(function(char) {
      return char === '#' ? /\d/ : char
    })
  }
}

module.exports = maskFromString
